var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addImage, setInstrument } from "../../../../../../../../../../../redux/actions/canvas/canvas";
import { errorNotification } from "../../../../../../../../../../../redux/actions/notifications/notifications";
export var UploadImage = function () {
    var selectImageHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        var input, _a, file, extension, URLObj, source, selectedImage_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    input = document.createElement('input');
                    input.type = 'file';
                    input.accept = 'image/jpeg, image/png, image/jpg';
                    // Ожидаем выбор файла пользователем
                    return [4 /*yield*/, new Promise(function (resolve) {
                            input.onchange = resolve;
                            input.click();
                        })];
                case 1:
                    // Ожидаем выбор файла пользователем
                    _b.sent();
                    if (input.files) {
                        _a = __read(input.files, 1), file = _a[0];
                        if (file) {
                            extension = file.name.split('.').pop() || '';
                            if (['jpeg', 'jpg', 'png'].includes(extension.toLowerCase())) {
                                URLObj = window.URL || window.webkitURL;
                                source = URLObj.createObjectURL(file);
                                selectedImage_1 = new Image();
                                selectedImage_1.src = source;
                                selectedImage_1.onload = function () {
                                    return __awaiter(this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            addImage(selectedImage_1);
                                            setInstrument('cursor');
                                            return [2 /*return*/];
                                        });
                                    });
                                };
                            }
                            else {
                                errorNotification('Invalid image extension. Only .jpeg, .jpg, .png');
                            }
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", __assign({ className: 'context-block' }, { children: _jsxs("button", __assign({ className: "flex gap-2 upload-image", onClick: selectImageHandler }, { children: [_jsx("i", { className: "pi pi-upload" }), _jsx("span", { children: "Upload image" })] })) })));
};
